export const ENGLISH_CODE = 'en'
export const JAPANESE_CODE = 'ja'
export const ENGLISH_DISPLAY = 'English'
export const JAPANESE_DISPLAY = '日本語'
